export class LoyaltySite {
    public LoyaltySiteId: string;
    public siteId: string;
    public createDateUtc: string;
    public userName: string;
    public plainTextPassword: string;
    public password: string;
    public confirmPassword: string;
    public SiteName: string;
    public address1: string;
    public address2: string;
    public suburb: string;
    public postalCode: string;
    public email: string;
    public manager: string;
    public latitude: number;
    public longitude: number;
    public openingTime: number;
    public closingTime: number;
    public mobileNumber: string;
    public status: boolean = false;
    public city: string;
    public provinceID: number;
    public country: string;
    public CurrentId: string;
    public LocationGroupID: number;
    public TradingHours: string;
    public POS: string;
    public LocationType: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/loyalty-site/loyalty-site.ts